// @flow

import type { RunCodeOpts } from 'frame/jsEnv/jsEnv'

import { getJsEnv } from 'frame/jsEnv/jsEnv'
import { formatNumber, formatDate } from 'frame/core/format'
import { encrypt } from 'frame/core/encrypt'
import {
  memoryStore,
  localStore,
  sessionStore,
  cookieStore
} from 'frame/core/store'
import * as browserEnv from 'frame/core/browserEnv'

import * as allApp from 'frame/core/app/all'

const global = {
  // JS native
  Math,
  Date,
  Array,
  Object,
  parseInt,
  parseFloat,
  console,
  location: window.location,
  encodeURIComponent,
  decodeURIComponent,
  encodeURI,
  decodeURI,
  isNaN,
  // customer
  formatNumber,
  formatDate,
  browserEnv,
  allApp,
  encrypt,
  JSON,

  // store
  memoryStore,
  localStore,
  cookieStore,
  sessionStore
}

export class EasyJsEnv {
  env: { runCode: (string, opts?: RunCodeOpts) => any };
  baseContext: Object;
  compInputData: ?Object;
  additionalData: ?Object;

  constructor (baseContext: Object, compInputData: ?Object) {
    this.baseContext = baseContext
    this.compInputData = compInputData
    this.env = getJsEnv([
      global,
      baseContext,
      compInputData,
      { getString: this.getStringWithAdditionCtx.bind(this) }
    ])
  }

  setDataCode (dataCode: string) {
    this.additionalData = this.runCode(dataCode)
    this.env = getJsEnv([
      global,
      this.baseContext,
      this.compInputData,
      this.additionalData
    ])
  }

  runCode (code: string, opts?: RunCodeOpts): any {
    return this.env.runCode(code, opts)
  }

  getString (tpl: ?string, opts?: RunCodeOpts): string {
    if (tpl == null) {
      return ''
    }
    return this.runCode('`' + tpl + '`', opts)
  }

  getContext () {
    return {
      baseContext: this.baseContext,
      compInputData: this.compInputData,
      additionalData: this.additionalData
    }
  }

  getComponentData () {
    return { ...this.compInputData, ...this.additionalData }
  }

  getStringWithAdditionCtx (tpl: string, contextAdded: Object): string {
    return this.runCodeWithAdditionalCtx('`' + tpl + '`', contextAdded)
  }

  runCodeWithAdditionalCtx (code: string, contextAdded: Object): any {
    const env = getJsEnv([
      global,
      this.baseContext,
      this.compInputData,
      this.additionalData,
      contextAdded,
      { getString: this.getStringWithAdditionCtx.bind(this) }
    ])
    return env.runCode(code)
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/easyJsEnv.js